<script setup>
const props=defineProps({plant:{type:Object,required:true},label:{type:String,default:''}});
const failed=ref(false);
watch(()=>props.plant.image,()=>failed.value=false);
</script>

<template>
 <NuxtLink class="plant-preview-link" :to="'/catalog/product-'+plant.id" :title="plant.title" :aria-label="plant.title">
  <CatalogPlantImage class="plant-preview-photo" :src="!failed?plant.image:null" :alt="plant.title" aria-hidden="true" width="32" height="32" loading="lazy" decoding="async" @error="failed=true" />
  <span class="plant-preview-title">{{label||plant.title}}</span>
 </NuxtLink>
</template>

<style scoped>
.plant-preview-link{display:flex;align-items:center;gap:8px;min-width:0;max-width:100%;min-height:44px;padding:4px 12px 4px 4px;color:var(--uo-color-text-primary);border:1px solid var(--uo-color-border-default);border-radius:var(--uo-radius-pill);text-decoration:none;font-size:14px;line-height:20px;font-weight:500}
.plant-preview-link:hover{background:var(--uo-color-surface-selected)}
.plant-preview-link:hover .plant-preview-title{text-decoration:underline;text-underline-offset:3px}
.plant-preview-link:focus-visible{outline:2px solid var(--uo-color-action-primaryBackground);outline-offset:2px}
.plant-preview-photo{display:block;width:32px;height:32px;flex:0 0 32px;object-fit:cover;border-radius:var(--uo-radius-pill);border:1px solid var(--uo-color-border-default);background:var(--uo-color-surface-subtle)}
.plant-preview-title{min-width:0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
</style>
